// Angular
import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { Router } from '@angular/router';

// Local library
import {
  CommonFacade,
  ENVIRONMENT,
  PermissionService,
  SessionService
} from '@amwager/data-access';
import {
  RaceStringToRangePipe,
  GetCurrentRacePipe,
  GetRaceStatusPipe,
  SortEventsPipe,
  GetEventStatusPipe,
  GetTrackTypePipe,
  ConvertToRangePipe,
  LegHeightDirective,
  OrdinalsPipe,
  HorseWeightPipe,
  UnsubscribeObservableService,
  FormatAmountPipe,
  MatrixDataPipe,
  EmptySuitPipe,
  GetTrackIconPipe,
  GeoLocationService,
  MatNotificationService,
  DateFormatPipe,
  NumberWithCommasPipe,
  ToNumberPipe,
TranslatePipe
} from '@amwager/util';
import {
  GUEST,
  IGeoLocationModel,
  IGetEventsDetailsResponse,
  ILeg,
  IPool,
  LoggerService,
  isOnline$
} from '@amwager/util-ts';
import {
  IBetTicket,
  IReplays,
  ISelectedRace,
  ISelectedRaceMatrix,
  ISelectedRaceEloRatings,
  WagerFacade,
  WagerService,
  RaceService,
  RunnerService
} from '@amwager/wager/data-access';
import { AccountFacade } from '@amwager/account/data-access';
import { AuthFacade } from '@amwager/authentication/data-access';
import { Observable, Subscription, takeUntil } from 'rxjs';
import * as _ from 'lodash';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Third party
import moment from 'moment';

@Component({
  selector: 'feature-mat-runner',
  standalone: true,
  imports: [
    CommonModule,
    RaceStringToRangePipe,
    GetCurrentRacePipe,
    GetRaceStatusPipe,
    SortEventsPipe,
    GetEventStatusPipe,
    GetTrackTypePipe,
    ConvertToRangePipe,
    LegHeightDirective,
    OrdinalsPipe,
    HorseWeightPipe,
    FormatAmountPipe,
    MatrixDataPipe,
    EmptySuitPipe,
    GetTrackIconPipe,
    DateFormatPipe,
    NumberWithCommasPipe,
    ToNumberPipe,
    MatProgressSpinnerModule,
    TranslatePipe
  ],
  providers: [DatePipe],
  templateUrl: './runner.component.html',
  styleUrls: ['./runner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RunnerComponent extends
  UnsubscribeObservableService implements
  OnInit, OnChanges, OnDestroy, AfterViewChecked {
  @Input() events!: any;
  @Input() selectedEvent!: IGetEventsDetailsResponse;
  @Input() selectedRace!: ISelectedRace;
  @Input() isShowRunnners = false;
  @Input() selectedPool!: IPool;
  @Input() selectedModifier!: string;
  @Input() selectedAmount!: number;
  @Input() dblPkArray!: any;
  @Input() triggerLiveVideo!: boolean;
  @Input() poolMatrix!: any;
  @Output() doShowBetFn = new EventEmitter<any>();
  // Signals the parent (wager page) that a user-initiated replay is
  // in flight so it can open a single guarded replay dialog.
  @Output() replayRequested = new EventEmitter<void>();
  // Emits the race currently being viewed (DBL/PK pools) so the parent
  // race-details header can follow the R1/R2/R3 column being shown.
  @Output() displayedRaceChange = new EventEmitter<any>();

  @ViewChild('wagingSectionTemplateRef') wagingSectionTemplateRef!: ElementRef;
  @ViewChild('runnerRef') runnerRef!: ElementRef;
  @ViewChildren('runnerInfo') runnersInfo!: QueryList<ElementRef>;
  @ViewChildren('legsInfo') legsInfo!: QueryList<ElementRef>;
  @ViewChildren('currentEntries') currentEntries!: QueryList<ElementRef>;
  @ViewChildren('currentRunners') currentRunners!: QueryList<ElementRef>;
  @ViewChildren('legBets') legBets!: QueryList<ElementRef>;

  matrixWinAllOdds: any[] = [];

  geoLocation!: IGeoLocationModel;
  private getSelectedEventTrackSubs!: Subscription;

  setRunnerScrollTimeout: any;
  triggerSetRunnerHeight: boolean = false;

  prevPoolId: string = '';
  prevModifierId: string = '';
  PoolIds: string[] = ['EX','QU','TRL','TRI','SPR','OMN','PEN','HEX'];
  vertical: string[] = ['EX','TRI','SPR','PEN','HEX'];
  horizontal: string[] = ['DBL'];

  // $1 Pays only for single-race pools (matches legacy poolRaces === 1)
  get hidePays(): boolean {
    if (!this.selectedPool) return false;
    return this.selectedPool.PoolRaces !== 1;
  }

  // Stake only for single-leg, single-race pools (matches legacy legs * races === 1)
  get hideStake(): boolean {
    if (!this.selectedPool) return false;
    return (this.selectedPool.Legs || 1) * (this.selectedPool.PoolRaces || 1) !== 1;
  }

  // private subsUserAccountResponse!: Subscription;
  // event$!: Observable<IGetEventsDetailsResponse[]>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details$!: Observable<any[]>;
  event$!: Observable<IGetEventsDetailsResponse[]>;
  ticket$!: Observable<IBetTicket>;
  ticket!: IBetTicket;
  baseAmount!: number;
  balanceAmount!: number;

  bets!: number;
  runners!: string;
  legs!: ILeg[];
  legResult: any[] = [];
  // countPoolLegs!: number;
  // countLegs!: number;
  // dblPkLegs!: number[];

  dblPkLegs: any[] = [];
  dblPkLegsView: {
    identity: any;
    cells: any[];
    isFullyHidden: boolean;
    isActiveHidden: boolean;
    runnerIndex: number;
    useMatrix: boolean;
    uiClass: string;
    idClass: string;
    activeRaceId: number;
  }[] = [];

  storeStructure: { leg: any, runners: any[] }[] = [];
  storeStructureCopy!: any;
  storedSelectedRunners = '';
  cantBet!: boolean;
  showCurrentInfo!: number;
  showCurrentInfoRunnersIndex: number | undefined;

  isShowFooter:boolean = false;
  isShowBetPreview:boolean = false;

  isClearWager!:boolean;
  requireConfirmation!: boolean;
  isExoticSelections!: boolean;
  maxWagerTotal!: number;
  isWagerLimit: boolean = false;
  wagerLimit: number = 0;

  setTimer: number = 0;
  isProcessingBet: boolean = false;
  replayTypes: number[] = [0, 4, 2, 1, 3];
  // wager replays
  runnerWithReplays: any[] = [];
  // indexPostReplays: number = 0;
  indexGetReplays: number = 0;

  indexCountReplays: number = 0;
  isLoadingReplays: boolean = false;

  dutchTicket!: any;
  runnersWithStake!: any;
  dutchROI: string = '';
  dutchTotalAmount: number = 0;
  setTimerABC: number = 0;
  nestedRunnersABC!: any;
  abcTicket!: any;
  abcTotalAmount: number = 0;
  dutchAbcErrorMsg!: any;
  disableSavedBetBtn: boolean = false;
  disableBetNowBtn: boolean = false;
  countryStateList!: any;
  isBlockJurisdiction: boolean = false;
  isBlockJurisdictionMsg: string = '';

  isExceedsSaveBetErr: boolean = false;
  isExceedsBetNowErr: boolean = false;
  isGenericSaveBetErr: boolean = false;
  isGenericBetNowErr: boolean = false;

  private subsGetBetResponse!: Subscription;

  matrix: any;
  dutchEnum: string[] = [
    'None',
    'DutchCost',
    'DutchPayout',
    'ABC'
  ];
  nestedArrayABC: {
    runnerId: number; legId: number; value: string
  }[][] = [];
  abcArray: string[] = ['A', 'B', 'C', ''];
  modifierEnam: string[] = [
    'Straight',
    'Wheel',
    'Box',
    'PowerBox',
    'Leading',
    'KeyWheel',
    'KeyBox',
    'DutchCost',
    'DutchPayout',
    'ABC'
  ];

  private modal!: HTMLIonModalElement;
  private runnerReplaysModal!: HTMLIonModalElement;

  private previousSelectedRaceID!: string;
  private isClearCustomState = false;

  /**
   * Flashes true for a short window whenever the selected event
   * or race changes — swaps the runner table for a skeleton while
   * the store clears old data and refetches fresh runners / odds.
   */
  showSelectionSkeleton = false;

  /** Timer handle for the skeleton flash; cleared on destroy. */
  private selectionSkeletonTimeoutId?: ReturnType<typeof setTimeout>;

  /** Skip the very first `ngOnChanges` so we don't flash on mount. */
  private hasSeenFirstSelection = false;


  isOnline: boolean = true;

  // Elo ratings from the store, keyed by `${eventId}:${raceId}`
  eloRatings: Record<string, ISelectedRaceEloRatings> = {};

  controller = {
    basic: false,
    info: false,
    stats: false,
    replays: false
  };

  // Track-type codes (see TRACK_TYPE_lIST) used by the Info tab.
  private readonly TRACK_GREYHOUND = 2;
  private readonly TRACK_HARNESS = 4;

  // Role label for the Info row — varies by track type.
  get runnerRoleLabel(): string {
    const type = this.selectedEvent?.ToteResponse?.EventDetail?.TrackType;
    if (type === this.TRACK_HARNESS) return 'Driver';
    if (type === this.TRACK_GREYHOUND) return 'Kennel';
    return 'Jockey';
  }

  // Harness races carry no listed weight.
  get isHarnessTrack(): boolean {
    return this.selectedEvent?.ToteResponse?.EventDetail?.TrackType === this.TRACK_HARNESS;
  }

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly permissionService: PermissionService,
    private readonly sessionService: SessionService,
    private geoLocationService: GeoLocationService,
    private readonly router: Router,
    private readonly elementRef: ElementRef,
    private renderer: Renderer2,
    private readonly matNotificationService: MatNotificationService,
    private readonly wagerFacade: WagerFacade,
    private readonly accountFacade: AccountFacade,
    private readonly authFacade: AuthFacade,
    private readonly commonFacade: CommonFacade,
    private readonly wagerService: WagerService,
    private readonly raceService: RaceService,
    private readonly runnerService: RunnerService,
    // private readonly authFacade: AuthFacade,
    private readonly ngZone: NgZone,
    private readonly loggerService: LoggerService,
    @Inject(ENVIRONMENT) readonly environment: string,
  ) {

    super();

    this.observerGetRaceMatrix();
    this.observerLogout();

    this.wagerFacade.getRaceMatrix$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((callback) => {
        if (callback === undefined) return;

        this.poolMatrix = callback;
        this.cdRef.markForCheck();
      });

    // Keep local Elo ratings in sync with the store
    this.wagerFacade.getEloRatings$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((ratings) => {
        this.eloRatings = ratings ?? {};
        this.cdRef.markForCheck();
      });

    this.wagerFacade.getRaceAllOddsMatrixes$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((callback) => {
        if (callback === undefined) return;

        const data: any[] = [];
        const postTime = this.selectedRace?.PostTime?.replace('Z', '');

        _.forEach(callback.WIN?.response?.ToteMatrixSlim, (vT) => {
          const time = moment(postTime).diff(
            moment(vT?.TimeStamp?.replace('Z', '')),
            'minutes',
            true,
          );

          // hoisted: `time` is constant for the whole row, so skip the
          // inner column loop entirely when this snapshot is older than
          // the 20-minute sparkline window (matches the legacy behaviour
          // where the inner `return true` acted as a no-op continue).
          if (time > 20) return;

          const row: any = vT?.Row as any;
          const columns: any[] | undefined =
            row?.Columns ?? row?.[0]?.Columns;

          _.forEach(columns, (vC, kC) => {
            const index = kC as number;
            if (data[index] === undefined) {
              data.push({
                points: { show: false },
                lines: { show: true, width: 2 },
                color: (vC?.ColumnNumber ?? 1) - 1,
                label: '#' + vC?.ColumnNumber,
                data: [[time, vC?.DecimalOdds]],
              });
            } else {
              data[index].data.push([time, vC?.DecimalOdds]);
            }
          });
        });

        // Sparklines are a WIN-pool-only visualisation in the runner
        // view — for any other single-pool selection (PLC, SHW, EX, …)
        // we still cache the raw series but skip the draw. Multi-race
        // pools (PoolRaces > 1) are additionally guarded inside
        // `setRunnerChart` itself.
        if (this.selectedPool?.PoolId !== undefined && this.selectedPool?.PoolId !== 'WIN') {
          this.matrixWinAllOdds = data;
          this.cdRef.markForCheck();
          return;
        }

        this.matrixWinAllOdds = data;

        this.runnerService.setRunnerChart(
          this.matrixWinAllOdds,
          this.elementRef,
          this.selectedPool,
        );

        this.cdRef.markForCheck();
      });
  }

  /**
   * Init on load
   * @returns {void}
   */
  ngOnInit(): void {
    this.wagerService.checkConnectivity(
      isOnline$, this.environment
    ).subscribe((online: any) => {
      this.isOnline = online;
      this.commonFacade.setIsConnectedInternet('RunnerComponent:checkConnectivity', online);
    });

    setTimeout(() => {
      this.runnerService.runnerStripe(
        this.dblPkArray,
        this.runnersInfo.toArray(),
        this.currentEntries.toArray(),
        this.legBets.toArray()
      );
    }, 10);

    this.controller.basic = true;
    // this.baseAmount = 1;
    this.balanceAmount = 0;
    this.bets = 0;
    this.runners = '';

    // this.wagerFacade.getTicketGeoLocation$().subscribe((response?: IGeoLocationModel) => {
    //   if (response === undefined) return;
    //   this.geoLocation = response;
    // });

    this.accountFacade.getBalance$()
      .subscribe((res) => {
        if (res !== undefined) {
          this.balanceAmount = res;
        }
        this.cdRef.markForCheck();
      });

    this.showCurrentInfo = 0;
    this.showCurrentInfoRunnersIndex = 0;
    if (this.selectedRace !== undefined) {
      // Active R# column is derived from showCurrentInfo via [class.active].
      this.showCurrentInfo = this.selectedRace.RaceId as number;
    }

    this.accountFacade.isGetAccountPreferencesSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((callback) => {

        if (callback === undefined) return;

        const response = callback?.response;
        this.isClearWager = response?.AccountPreferences?.IsClearWager;
        this.requireConfirmation = response?.AccountPreferences?.RequireConfirmation;
        this.isExoticSelections = response?.AccountPreferences?.IsExoticSelections;
        this.isWagerLimit = response?.AccountPreferences?.IsWagerLimit;
        this.wagerLimit = response?.AccountPreferences?.WagerLimit;
        this.maxWagerTotal = response?.ToteResponse?.Limits?.MaxWagerTotal ?? 65000;
        this.cdRef.markForCheck();
      });

    // this.authFacade.jurisdictions('US');
    this.authFacade.getCountryStates$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response}) => {
        if (response !== undefined)
          this.countryStateList = response;
      });

    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
        if (isLogout) {
          this.runnerService.clearLegRoundSelector(this.elementRef);
          const {
            resultClearCustomStateStoreStructure,
            resultClearCustomStateStoreStructureCopy,
            resultNestedArrayABC,
            showBetResult
          } = this.runnerService.clearCustomState(
            this.storeStructure,
            this.storeStructureCopy,
            this.elementRef,
            this.dblPkArray,
            this.runnersInfo,
            this.currentEntries,
            this.legBets,
            this.selectedEvent,
            this.selectedRace,
            this.selectedPool,
            this.selectedModifier,
            this.baseAmount,
            this.poolMatrix,
            this.events,
            this.maxWagerTotal,
            this.legResult,
            this.dutchROI,
            this.dutchTicket,
            this.dutchAbcErrorMsg,
            this.abcTicket,
            this.abcTotalAmount,
            this.countryStateList,
            this.isBlockJurisdiction,
            this.isBlockJurisdictionMsg,
            this.cantBet
          );
          this.storeStructure = resultClearCustomStateStoreStructure;
          this.storeStructureCopy = resultClearCustomStateStoreStructureCopy;
          this.nestedArrayABC = resultNestedArrayABC;

          this.doShowBetFn.emit(showBetResult);
        }
      });

    // `BetService` fires this signal after a successful save-bet /
    // submit-bet API response when the user has the "Clear on
    // Wager" account preference enabled. Mirrors what the legacy
    // `bet.service.ts (844-851)` snippet attempted to do, but
    // executed on the actual owner of the state (this component)
    // instead of on `BetService` where the fields no longer live.
    this.runnerService.clearRunnerWagerState$
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(() => {
        this.storeStructure = [];
        this.storeStructureCopy = [];
        this.nestedArrayABC = [];
        this.storedSelectedRunners = '';

        // Re-seed the ABC matrix using the current pool / modifier
        // so the user can immediately start a fresh bet without
        // having to re-pick around. Mirrors the same call site
        // used by `ngOnChanges` when the pool changes.
        const {
          resultNestedArrayABC: resultInitNestedArrayABC
        } = this.runnerService.initNestedArrayABC(
          this.dblPkArray,
          this.selectedRace,
          this.selectedPool,
          this.selectedModifier
        );
        if (resultInitNestedArrayABC !== undefined) {
          this.nestedArrayABC = resultInitNestedArrayABC;
        }

        // Clear leg / round DOM highlights using THIS component's
        // elementRef so the queries actually find the matching
        // nodes. `BetService` also runs the same calls against its
        // own elementRef (the bet-preview's), so this is the half
        // that actually unhighlights the runner-table cells.
        this.runnerService.clearActiveAllLeg(this.elementRef);
        this.runnerService.clearLegRoundSelector(this.elementRef);

        // OnPush parent (`wager.component`) won't re-render the
        // bound `@Input`s without a manual tick — without this the
        // user would see stale "active" highlights for a frame
        // until the next CD cycle kicks in.
        this.cdRef.markForCheck();
      });

    this.wagerFacade.getLatestFinishedEvent$()
      .subscribe((callback: any) => {
        // IGetEventsDetailsResponse
        if (callback?.event === undefined && callback?.raceId === undefined) return;

        if (callback?.event !== undefined && callback?.raceId !== undefined)
          this.runnerReplaysModal.dismiss();

        this.cdRef.markForCheck();
      });

    this.wagerFacade.getReplays$()
      .subscribe((replays?: IReplays) => {

        if (replays?.isSuccess !== undefined)
          this.indexCountReplays = this.indexCountReplays + 1;

        if (replays?.response !== undefined && replays?.isSuccess !== undefined) {

          const availableVideos = replays?.response?.AvailableVideos;

          _.flatMap(availableVideos, (event) => {
            _.map(event, (item, breed) => {
              _.map(item, (data) => {
                const video = {
                  track: data?.TrackName || data?.EventName,
                  trackId: data?.TrackId,
                  date: data?.RaceDay,
                  breed,
                  race: data?.RaceId,
                  distance: data?.Distance,
                  surface: data?.Surface,
                  purse: data?.Purse,
                };

                _.forEach(this.runnerWithReplays, (runner) => {
                  const entry = _.find(runner.entries, ['name', replays?.response?.runnerName]);
                  if (entry) {
                    entry.availableReplays = [...(entry.availableReplays || []), video];
                  }
                });

              });
            });
          });

          _.forEach(this.runnerWithReplays, (runner) => {
            _.forEach(runner.entries, (entry) => {
              entry.availableReplays = _.orderBy(
                entry.availableReplays || [],
                ['date', 'race', 'track'],
                ['desc', 'asc', 'asc']
              );
            });
          });
        }

        if (this.indexGetReplays === this.indexCountReplays) {

          // if (replays !== undefined) {
          //   setTimeout(()=>{
          //     this.runnerService.setLegBetHeight(
          //       this.elementRef,
          //       this.dblPkArray,
          //       this.runnersInfo.toArray(),
          //       this.currentEntries.toArray()
          //     );
          //   }, 100);
          // }

          this.isLoadingReplays = false;
        }

        this.cdRef.markForCheck();
      });
  }

  /**
   * On changes
   * @param {SimpleChanges} changes - hook changes
   * @returns {void}
   */
  ngOnChanges(changes: SimpleChanges): void {

    // Refresh per-runner Elo ratings whenever the race/pool set changes
    if (changes['selectedRace'] || changes['selectedPool'] || changes['dblPkArray']) {
      this.refreshEloRatings();
    }

    if (
      changes['selectedRace'] !== undefined &&
      changes['selectedRace'].currentValue !== undefined
    ) {
      if (
        (
          changes['selectedRace'].currentValue.eventId + '-' +
          changes['selectedRace'].currentValue.RaceId
        )
          !== this.previousSelectedRaceID
      ) {
        this.previousSelectedRaceID = changes['selectedRace'].currentValue.eventId + '-' +
          changes['selectedRace'].currentValue.RaceId;
        this.isClearCustomState = true;

        // Skeleton flash on race change (skip the very first mount
        // so the parent-level page skeleton owns the initial view).
        if (this.hasSeenFirstSelection) this.flashSelectionSkeleton();
        this.hasSeenFirstSelection = true;
      }
      else this.isClearCustomState = false;
    }

    if (
      changes['selectedRace'] !== undefined &&
      changes['selectedRace'].currentValue !== undefined
    ) {

      if (changes['selectedRace'].currentValue && this.isClearCustomState) {
        // encase empty entries
        const updatedRunners = this.raceService.processFillInRunnersNonDblPk(
          changes['selectedRace'].currentValue.Runners
        );
        const updatedRace = _.cloneDeep(changes['selectedRace'].currentValue);
        updatedRace.Runners = updatedRunners;
        this.selectedRace = updatedRace;

        this.runnerWithReplays = [];
        // this.storeStructureCopy = [];
        // Race changed: snap tabs back to Basic so a lingering Info/
        // Stats/Replays panel doesn't keep showing the previous race.
        this.controller = { basic: true, info: false, stats: false, replays: false };
        this.isLoadingReplays = false;
        this.prevModifierId = '';

        const {
          resultClearCustomStateStoreStructure,
          resultClearCustomStateStoreStructureCopy,
          resultNestedArrayABC,
          showBetResult
        } = this.runnerService.clearCustomState(
          this.storeStructure,
          this.storeStructureCopy,
          this.elementRef,
          this.dblPkArray,
          this.runnersInfo,
          this.currentEntries,
          this.legBets,
          this.selectedEvent,
          this.selectedRace,
          this.selectedPool,
          this.selectedModifier,
          this.baseAmount,
          this.poolMatrix,
          this.events,
          this.maxWagerTotal,
          this.legResult,
          this.dutchROI,
          this.dutchTicket,
          this.dutchAbcErrorMsg,
          this.abcTicket,
          this.abcTotalAmount,
          this.countryStateList,
          this.isBlockJurisdiction,
          this.isBlockJurisdictionMsg,
          this.cantBet
        );
        this.runnerService.clearLegRoundSelector(this.elementRef);
        this.showCurrentInfo = changes['selectedRace'].currentValue.RaceId;
        // Switching race also resets the active-race index so the multi-
        // race table is tied to the new race's first leg, not a stale
        // index left over from a longer previous pool.
        this.showCurrentInfoRunnersIndex = 0;
        const defaultPool = changes['selectedRace'].currentValue.Pools?.[0] as IPool;
        this.selectedPool = defaultPool;

        // Realign dblPkArray with the new race's default pool. Without this a
        // stale multi-race (DBL/PK) array from the previous pool keeps the old
        // table rendered until the pool component re-emits.
        const dblPkResult = defaultPool
          ? this.raceService.fetchDblPkArrayAndNone(
              defaultPool,
              this.selectedEvent,
              this.selectedRace,
              'web'
            )
          : undefined;
        this.dblPkArray = dblPkResult?.dblPkArray ?? '';
        this.dblPkLegs = this.dblPkArray?.length > 0
          ? this.runnerService.groupRunnerEntries(this.dblPkArray)
          : [];

        this.storeStructure = resultClearCustomStateStoreStructure;
        this.storeStructureCopy = resultClearCustomStateStoreStructureCopy;
        this.nestedArrayABC = resultNestedArrayABC;
        this.abcTotalAmount = 0;

        this.doShowBetFn.emit(showBetResult);
      }

      if (this.storeStructure?.length) {

        if (
          this.selectedRace?.RaceStatus === 1 ||
          this.selectedRace?.RaceStatus === 2 ||
          this.selectedRace?.RaceStatus === 4 ||
          this.selectedEvent?.ToteResponse?.EventDetail?.EventStatus === 'Closed'
        ) this.cantBet = true;

        setTimeout(()=>{
          this.runnerService.isActiveRunners(
            this.nestedArrayABC,
            this.storeStructure,
            this.selectedModifier,
            this.elementRef,
            this.renderer
          );
        }, 100);
      }

      this.dutchTicket = '';
      this.dutchROI = '';
      this.dutchAbcErrorMsg = '';

      this.rebuildDblPkLegsView();
    }

    if (changes['selectedPool'] !== undefined) {

      if (changes['selectedPool'].currentValue) {

        this.storeStructureCopy = [];

        // Reset the active-race indicator BEFORE rebuilding the view.
        // A stale showCurrentInfoRunnersIndex from a longer pool (e.g.
        // PK4 -> DBL with index=3) would point past the new dblPkArray,
        // causing every row's identity to resolve to null and the table
        // to render empty runner name, ML, odds and color tag.
        this.showCurrentInfoRunnersIndex = 0;
        if (this.dblPkArray?.length > 0) {
          this.showCurrentInfo = this.dblPkArray[0]?.RaceId ?? this.showCurrentInfo;
        } else if (this.selectedRace?.RaceId !== undefined) {
          this.showCurrentInfo = this.selectedRace.RaceId as number;
        }

        // When switching among DBL/PK/GSL/non (any non-exotic-to-exotic
        // transition), the previously selected bet legs must not bleed
        // across pools. pool.component clears the visual pills but only
        // when its checkExotic returns false; we mirror the same guard
        // here so the runner-side state is always coherent regardless of
        // ordering, and we also wipe stale dblPkLegs when leaving a
        // multi-race pool entirely (dblPkArray becomes '' or empty).
        const prevPoolId = changes['selectedPool'].previousValue?.PoolId || '';
        const currPoolId = changes['selectedPool'].currentValue?.PoolId || '';
        const isExoticToExoticTransition =
          this.isExoticSelections &&
          this.PoolIds.includes(currPoolId) &&
          this.PoolIds.includes(prevPoolId);
        if (!isExoticToExoticTransition) {
          this.runnerService.clearLegRoundSelector(this.elementRef);
          this.runnerService.clearActiveAllLeg(this.elementRef);
        }

        if (
          this.runnersInfo !== undefined &&
          this.dblPkArray?.length > 0
        ) {

          // this.countPoolLegs  = this.selectedPool ? this.selectedPool.Legs : 0;
          // this.countLegs = this.dblPkArray.length || this.selectedPool.PoolRaces;
          // this.dblPkLegs = _.range(this.countPoolLegs * this.countLegs);

          this.dblPkLegs = this.runnerService.groupRunnerEntries(this.dblPkArray);
        } else {
          // Leaving a multi-race pool for a single-race pool: dblPkArray
          // becomes '' (or empty). Drop stale multi-race rows so a quick
          // round-trip (DBL -> WIN -> DBL) never momentarily renders the
          // old runners against the new race set.
          this.dblPkLegs = [];
        }
        this.rebuildDblPkLegsView();

        // setTimeout(() => {
        //   this.runnerService.setBetLegHeightPool(
        //     this.elementRef,
        //     this.runnersInfo.toArray(),
        //     this.selectedPool,
        //     true
        //   );
        // }, 10);

        const {
          resultNestedArrayABC: resultInitNestedArrayABC
        } = this.runnerService.initNestedArrayABC(
          this.dblPkArray,
          this.selectedRace,
          this.selectedPool,
          this.selectedModifier
        );
        this.nestedArrayABC = resultInitNestedArrayABC;

        if (changes['selectedPool'].previousValue !== undefined) {
          this.prevPoolId = changes['selectedPool'].previousValue?.PoolId;
          const {
            resultIsExotic,
            resultStoreStructure,
            resultStoredSelectedRunners,
            resultShowBetResult
          } = this.runnerService.checkExotic(
            changes['selectedPool'].previousValue?.PoolId,
            '',
            '',
            false,
            this.PoolIds,
            this.isExoticSelections,
            this.nestedArrayABC,
            this.dblPkArray,
            this.legBets,
            this.selectedEvent,
            this.selectedRace,
            this.selectedPool,
            this.selectedModifier,
            this.baseAmount,
            this.poolMatrix,
            this.events,
            this.maxWagerTotal,
            this.legResult,
            this.dutchROI,
            this.dutchTicket,
            this.dutchAbcErrorMsg,
            this.abcTicket,
            this.abcTotalAmount,
            this.countryStateList,
            this.isBlockJurisdiction,
            this.isBlockJurisdictionMsg,
            this.storeStructure,
            this.storeStructureCopy,
            this.runnersInfo,
            this.currentEntries,
            this.currentRunners,
            this.cantBet,
            this.elementRef,
            this.renderer
          );

          if (resultIsExotic) {

            this.storeStructure = resultStoreStructure;
            this.storedSelectedRunners = resultStoredSelectedRunners;

            const {
              resultShowCurrentInfo
            } = this.runnerService.setShowCurrentInfoByRace(
              this.dblPkArray,
              this.runnersInfo,
              this.currentEntries,
              this.legBets,
              this.elementRef
            );
            this.showCurrentInfo = resultShowCurrentInfo;

            // `resultShowBetResult` is already the unwrapped payload
            // (see checkExotic: `resultShowBetResult: showBetResult?.payload`);
            // emit it as-is so the bet preview correctly reflects the
            // exotic-to-exotic transition.
            this.doShowBetFn.emit(resultShowBetResult);
            return;
          }
        }

        const {
          resultClearCustomStateStoreStructure,
          resultClearCustomStateStoreStructureCopy,
          resultNestedArrayABC: resultClearCustomStateNestedArrayABC,
          showBetResult
        } = this.runnerService.clearCustomState(
          this.storeStructure,
          this.storeStructureCopy,
          this.elementRef,
          this.dblPkArray,
          this.runnersInfo,
          this.currentEntries,
          this.legBets,
          this.selectedEvent,
          this.selectedRace,
          this.selectedPool,
          this.selectedModifier,
          this.baseAmount,
          this.poolMatrix,
          this.events,
          this.maxWagerTotal,
          this.legResult,
          this.dutchROI,
          this.dutchTicket,
          this.dutchAbcErrorMsg,
          this.abcTicket,
          this.abcTotalAmount,
          this.countryStateList,
          this.isBlockJurisdiction,
          this.isBlockJurisdictionMsg,
          this.cantBet
        );
        this.storeStructure = resultClearCustomStateStoreStructure;
        this.storeStructureCopy = resultClearCustomStateStoreStructureCopy;
        this.nestedArrayABC = resultClearCustomStateNestedArrayABC;

        this.doShowBetFn.emit(showBetResult);

        const {
          resultShowCurrentInfo
        } = this.runnerService.setShowCurrentInfoByRace(
          this.dblPkArray,
          this.runnersInfo,
          this.currentEntries,
          this.legBets,
          this.elementRef
        );
        this.showCurrentInfo = resultShowCurrentInfo;
      }

      this.dutchTicket = '';
      this.dutchROI = '';
      this.abcTotalAmount = 0;
      this.dutchAbcErrorMsg = '';
    }

    if (changes['selectedModifier'] !== undefined) {
      if (
        changes['selectedModifier'].currentValue ||
        changes['selectedModifier'].currentValue === ''
      ) {
        this.prevModifierId = changes['selectedModifier'].currentValue;

        // this.selectedPool?.PoolId,
        // changes['selectedModifier'].previousValue,
        // changes['selectedModifier'].currentValue,
        // true,
        // this.PoolIds,
        // this.isExoticSelections,
        // this.nestedArrayABC,
        // this.selectedPool,
        // this.selectedModifier,
        // this.storeStructure,
        // this.storeStructureCopy,
        // this.currentRunners,
        // this.elementRef,
        // this.renderer

        // NOTE: when only the modifier changes (e.g. user selects ABC),
        // `changes['selectedPool']` is `undefined`, so reading
        // `.previousValue` off it crashes ngOnChanges. The "previous
        // pool" for a modifier-only transition is just the current pool
        // (the pool didn't change). The actual transition we are
        // describing here is a modifier transition, so we pass:
        //   - prevPoolId      = current pool's PoolId
        //   - prevModifierId  = changes['selectedModifier'].previousValue
        //   - modifierId      = changes['selectedModifier'].currentValue
        //   - modifier        = true  (this branch is a modifier change)
        const {
          resultIsExotic,
          resultStoreStructure,
          resultStoredSelectedRunners,
          resultShowBetResult
        } = this.runnerService.checkExotic(
          this.selectedPool?.PoolId,
          changes['selectedModifier'].previousValue,
          changes['selectedModifier'].currentValue,
          true,
          this.PoolIds,
          this.isExoticSelections,
          this.nestedArrayABC,
          this.dblPkArray,
          this.legBets,
          this.selectedEvent,
          this.selectedRace,
          this.selectedPool,
          this.selectedModifier,
          this.baseAmount,
          this.poolMatrix,
          this.events,
          this.maxWagerTotal,
          this.legResult,
          this.dutchROI,
          this.dutchTicket,
          this.dutchAbcErrorMsg,
          this.abcTicket,
          this.abcTotalAmount,
          this.countryStateList,
          this.isBlockJurisdiction,
          this.isBlockJurisdictionMsg,
          this.storeStructure,
          this.storeStructureCopy,
          this.runnersInfo,
          this.currentEntries,
          this.currentRunners,
          this.cantBet,
          this.elementRef,
          this.renderer
        );

        this.storeStructure = resultStoreStructure;
        this.storedSelectedRunners = resultStoredSelectedRunners;
        // `resultShowBetResult` is already the unwrapped payload (see
        // checkExotic: `resultShowBetResult: showBetResult?.payload`),
        // emit it as-is; double-unwrapping it would always emit
        // `undefined` and stop the bet preview from reflecting the new
        // exotic/modifier state.
        this.doShowBetFn.emit(resultShowBetResult);

        if (
          resultIsExotic &&
          this.selectedModifier.toLowerCase() !== 'dutchcost' &&
          this.selectedModifier.toLowerCase() !== 'abc'
        ) return;

        const {
          resultClearCustomStateStoreStructure,
          resultClearCustomStateStoreStructureCopy,
          resultNestedArrayABC,
          showBetResult
        } = this.runnerService.clearCustomState(
          this.storeStructure,
          this.storeStructureCopy,
          this.elementRef,
          this.dblPkArray,
          this.runnersInfo,
          this.currentEntries,
          this.legBets,
          this.selectedEvent,
          this.selectedRace,
          this.selectedPool,
          this.selectedModifier,
          this.baseAmount,
          this.poolMatrix,
          this.events,
          this.maxWagerTotal,
          this.legResult,
          this.dutchROI,
          this.dutchTicket,
          this.dutchAbcErrorMsg,
          this.abcTicket,
          this.abcTotalAmount,
          this.countryStateList,
          this.isBlockJurisdiction,
          this.isBlockJurisdictionMsg,
          this.cantBet
        );

        this.storeStructure = resultClearCustomStateStoreStructure;
        this.storeStructureCopy = resultClearCustomStateStoreStructureCopy;
        this.nestedArrayABC = resultNestedArrayABC;

        this.doShowBetFn.emit(showBetResult);
      }

      this.dutchTicket = '';
      this.dutchROI = '';
      this.abcTotalAmount = 0;
      this.dutchAbcErrorMsg = '';
      // Clear stale Dutch stakes so they don't show on non-Dutch modifiers
      this.runnersWithStake = null;
    }

    if (changes['selectedAmount'] !== undefined) {
      if (changes['selectedAmount'].currentValue) {
        this.baseAmount = changes['selectedAmount'].currentValue;

        if (this.selectedModifier.toLowerCase() === 'dutchcost') {
          const {
            dutchTotalAmount: resultDutchTotalAmount,
            dutchROI: resultDutchROI,
            dutchTicket: resultDutchTicket,
            runnersWithStake: resultRunnersWithStake,
            dutchAbcErrorMsg: resultDutchAbcErrorMsg,
            disableSavedBetBtn: resultDisableSavedBetBtn,
            disableBetNowBtn: resultDisableBetNowBtn,
            cantBet: resultCantBet
          } = this.runnerService.buildDutchWager(
            this.storeStructure,
            this.selectedEvent,
            this.selectedRace,
            this.selectedModifier,
            this.selectedPool,
            this.baseAmount,
            this.poolMatrix,
            this.events,
            this.maxWagerTotal,
            this.cantBet,
            this.dutchROI,
            this.dutchTicket,
            this.dutchAbcErrorMsg,
            this.isBlockJurisdiction,
            this.isBlockJurisdictionMsg
          );

          this.dutchTotalAmount = resultDutchTotalAmount;
          this.dutchROI = resultDutchROI;
          this.dutchTicket = resultDutchTicket;
          this.runnersWithStake = resultRunnersWithStake;
          this.dutchAbcErrorMsg = resultDutchAbcErrorMsg;
          this.disableSavedBetBtn = resultDisableSavedBetBtn;
          this.disableBetNowBtn = resultDisableBetNowBtn;
          this.cantBet = resultCantBet;
        }

        if (this.selectedModifier.toLowerCase() === 'abc') {
          const {
            abcTotalAmount: resultAbcTotalAmount,
            abcTicket: resultAbcTicket,
            dutchAbcErrorMsg: resultDutchAbcErrorMsg,
            disableSavedBetBtn: resultDisableSavedBetBtn,
            disableBetNowBtn: resultDisableBetNowBtn,
            cantBet: resultCantBet
          } = this.runnerService.buildAbcWager(
            this.storeStructure,
            this.selectedEvent,
            this.selectedRace,
            this.selectedModifier,
            this.selectedPool,
            this.baseAmount,
            this.maxWagerTotal,
            this.cantBet,
            this.abcTicket,
            this.dutchAbcErrorMsg,
            this.isBlockJurisdiction,
            this.isBlockJurisdictionMsg,
            this.elementRef
          );

          this.abcTotalAmount = resultAbcTotalAmount;
          this.abcTicket = resultAbcTicket;
          this.dutchAbcErrorMsg = resultDutchAbcErrorMsg;
          this.disableSavedBetBtn = resultDisableSavedBetBtn;
          this.disableBetNowBtn = resultDisableBetNowBtn;
          this.cantBet = resultCantBet;
        }

        const {
          payload
        } = this.runnerService.showBet(
          true,
          this.storeStructure,
          this.dblPkArray,
          this.runnersInfo,
          this.currentEntries,
          this.legBets,
          this.selectedEvent,
          this.selectedRace,
          this.selectedPool,
          this.selectedModifier,
          this.baseAmount,
          this.poolMatrix,
          this.events,
          this.maxWagerTotal,
          this.legResult,
          this.dutchROI,
          this.dutchTicket,
          this.dutchAbcErrorMsg,
          this.abcTicket,
          this.abcTotalAmount,
          this.countryStateList,
          this.isBlockJurisdiction,
          this.isBlockJurisdictionMsg,
          this.cantBet,
          this.elementRef,
        );

        payload.storedSelectedRunners = this.storedSelectedRunners;
        this.doShowBetFn.emit(payload);
      }
      else {
        const {
          resultClearCustomStateStoreStructure,
          resultClearCustomStateStoreStructureCopy,
          resultNestedArrayABC,
          showBetResult
        } = this.runnerService.clearCustomState(
          this.storeStructure,
          this.storeStructureCopy,
          this.elementRef,
          this.dblPkArray,
          this.runnersInfo,
          this.currentEntries,
          this.legBets,
          this.selectedEvent,
          this.selectedRace,
          this.selectedPool,
          this.selectedModifier,
          this.baseAmount,
          this.poolMatrix,
          this.events,
          this.maxWagerTotal,
          this.legResult,
          this.dutchROI,
          this.dutchTicket,
          this.dutchAbcErrorMsg,
          this.abcTicket,
          this.abcTotalAmount,
          this.countryStateList,
          this.isBlockJurisdiction,
          this.isBlockJurisdictionMsg,
          this.cantBet
        );

        this.storeStructure = resultClearCustomStateStoreStructure;
        this.storeStructureCopy = resultClearCustomStateStoreStructureCopy;
        this.nestedArrayABC = resultNestedArrayABC;

        this.doShowBetFn.emit(showBetResult);
      }
    }
  }

  /**
   * Clean up the skeleton flash timer. Parent unsubscribe helper
   * runs via the base class; only local timers need handling here.
   * @returns {void}
   */
  override ngOnDestroy(): void {
    this.toUnsubscribe();

    if (this.selectionSkeletonTimeoutId) {
      clearTimeout(this.selectionSkeletonTimeoutId);
      this.selectionSkeletonTimeoutId = undefined;
    }
  }

  /**
   * Flip the skeleton on for ~600 ms while the store swaps
   * runners / odds for the newly selected race. Guards against
   * overlapping flashes by resetting the pending timer.
   * @returns {void}
   */
  private flashSelectionSkeleton(): void {
    this.showSelectionSkeleton = true;
    this.cdRef.markForCheck();

    if (this.selectionSkeletonTimeoutId) {
      clearTimeout(this.selectionSkeletonTimeoutId);
    }
    this.selectionSkeletonTimeoutId = setTimeout(() => {
      this.showSelectionSkeleton = false;
      this.selectionSkeletonTimeoutId = undefined;
      this.cdRef.markForCheck();
    }, 600);
  }

  /**
   * After view checked
   * @returns {void}
   */
  ngAfterViewChecked(): void {

    if (this.selectedPool !== undefined) {
      // OLD (name allowlist skipped multi-race pools like QD/DQ/TT/TS/BQ/TR2/SP2):
      // const startsWithPK = /^PK/.test(this.selectedPool.PoolId || '');
      // const wordWithPK = /^PICK|Pick|pick/.test(this.selectedPool.PoolName || '');
      // if (
      //   this.selectedPool.PoolId === 'GSL' ||
      //   this.selectedPool.PoolId === 'DBL' ||
      //   startsWithPK || wordWithPK
      // ) {
      if ((this.selectedPool.PoolRaces || 1) > 1) {
        setTimeout(()=>{
          const customHeight = this.elementRef.nativeElement.querySelectorAll(
            `.custom-height`
          );
          if (customHeight.length) {
            return;
          }

          // Active R# column is derived from showCurrentInfo via [class.active].
          this.runnerService.setBetLegHeightPool(
            this.elementRef,
            this.runnersInfo.toArray(),
            this.legsInfo.toArray(),
            this.selectedPool,
            true
          );
          // this.setDynamicLegHeight();
        }, 10);
      }
    }

  }

  observerLogout(): void {
    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
      if (isLogout) {
        // Closing the shared dialog covers every alert this component
        // can have opened. The legacy ion modal handles tracked here
        // were removed along with the dead bet-flow code; bet-flow
        // dialogs now live in `BetPreviewComponent` / `BetService`.
        this.matNotificationService.hide();
      }
    });
  }

  observerGetRaceMatrix(): void {
    this.wagerFacade.getRaceMatrix$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((matrix?: ISelectedRaceMatrix) => {
        if (_.isEmpty(matrix)) return;

        try {
          this.matrix = matrix?.['WIN']?.response?.ToteResponse;
          if (this.selectedModifier.toLowerCase() === 'dutchcost')
            this.runnerService.buildDutchWager();
        } catch (error) {
          null
        }

        this.cdRef.markForCheck();

        // Odds cells just refreshed — redraw WIN sparklines from cache
        // in case the odds series arrived before these cells populated.
        if (this.selectedPool?.PoolId === undefined || this.selectedPool?.PoolId === 'WIN') {
          this.runnerService.setRunnerChart(null, this.elementRef, this.selectedPool);
        }
      });
  }

  showCurrentInfoByRace(raceId: number, indexRunner: number): void {
    if (!raceId) return;

    this.showCurrentInfo = raceId;
    this.showCurrentInfoRunnersIndex = indexRunner;
    this.rebuildDblPkLegsView();

    // Keep the parent race-details header in sync with the viewed race.
    // The active column highlight is derived from showCurrentInfo via [class.active].
    this.displayedRaceChange.emit(this.dblPkArray?.[indexRunner]);

    this.controller.replays = false;
    this.runnerWithReplays = [];
    this.isLoadingReplays = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  betAllRace($event: any, legId: number): void {
    if (!this.isOnline) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:betAllRace', false);
    }

    if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
      this.router.navigate(['login']);

      return;
    }

    if (!legId || this.selectedPool === undefined) return;

    const betAll = $event.target as HTMLElement;

    if (betAll.classList.contains('active')) {
      betAll.classList.remove('active');

      const {
        resultStoreStructure
      } = this.runnerService.removeLegByNumber(Number(betAll?.id), this.storeStructure);
      this.storeStructure = resultStoreStructure;

      const divLegs = this.elementRef.nativeElement.querySelectorAll(`.leg-${legId}`);
      divLegs.forEach((leg: HTMLElement) => {
        leg?.classList.remove('active');
        leg?.classList.remove('couple-entry');
        leg.innerHTML = '';
      });

      // init abc cycle
      this.nestedArrayABC = [];
      if (this.selectedModifier.toLowerCase() === 'abc') {
        if (this.dblPkArray) {

          const {
            resultNestedArrayABC
          } = this.runnerService.generateNestedArrayPKDbl(
            this.dblPkArray,
            this.convertLegRange(
              this.selectedPool?.Legs,
              this.selectedPool?.PoolRaces,
              this.selectedPool?.PoolId,
              this.selectedModifier
            ).length || 0,
            false
          );
          this.nestedArrayABC = resultNestedArrayABC;

        }
        else {

          const {
            resultNestedArrayABC
          } = this.runnerService.generateNestedArray(
            this.selectedRace?.Runners,
            this.convertLegRange(
              this.selectedPool?.Legs,
              this.selectedPool?.PoolRaces,
              this.selectedPool?.PoolId,
              this.selectedModifier
            ).length || 0,
            false
          );
          this.nestedArrayABC = resultNestedArrayABC;

        }
      }

      betAll.innerText = 'All';
    }
    else {
      betAll.classList.add('active');
      let i = 0;

      // init abc cycle
      this.nestedArrayABC = [];
      if (this.selectedModifier.toLowerCase() === 'abc') {
        if (this.dblPkArray) {

          const {
            resultNestedArrayABC
          } = this.runnerService.generateNestedArrayPKDbl(
            this.dblPkArray,
            this.convertLegRange(
              this.selectedPool?.Legs,
              this.selectedPool?.PoolRaces,
              this.selectedPool?.PoolId,
              this.selectedModifier
            ).length || 0,
            true
          );
          this.nestedArrayABC = resultNestedArrayABC;

        }
        else {

          const {
            resultNestedArrayABC
          } = this.runnerService.generateNestedArray(
            this.selectedRace?.Runners,
            this.convertLegRange(
              this.selectedPool?.Legs,
              this.selectedPool?.PoolRaces,
              this.selectedPool?.PoolId,
              this.selectedModifier
            ).length || 0,
            true
          );
          this.nestedArrayABC = resultNestedArrayABC;

        }
      }

      const divLegs = this.elementRef.nativeElement.querySelectorAll(`.leg-${legId}`);
      divLegs.forEach((leg: HTMLElement) => {

        if (!leg?.classList.contains('sub-couple-entry')) {
          leg?.classList.add('active');
          if (leg?.classList.length > 1) {
            const runnerId = leg?.classList[0].split('-');
            leg.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.runnerService.findABCValue(Number(legId), Number(runnerId[1]), this.nestedArrayABC)
              :
            runnerId[1];
          }
        }
        else if (i === 0 && leg?.classList.contains('sub-couple-entry')) {
          leg?.classList.add('active');
          const runnerId = leg?.classList[0].split('-');
          leg.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
          this.runnerService.findABCValue(Number(legId), Number(runnerId[1]), this.nestedArrayABC)
            :
          runnerId[1]+
            (leg?.getAttribute('data-entry-id') ? leg?.getAttribute('data-entry-id') : '');
        }
        else if (i > 0) {
          if (leg) {
            leg?.classList.add('couple-entry');
            const runnerId = leg?.classList[0].split('-');
            leg.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.runnerService.findABCValue(Number(legId), Number(runnerId[1]), this.nestedArrayABC)
              :
            runnerId[1]+
            (leg?.getAttribute('data-entry-id') ? leg?.getAttribute('data-entry-id') : '');
          }
        }
        else {
          if (leg) {
            leg?.classList.add('active');
            const runnerId = leg?.classList[0].split('-');
            leg.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.runnerService.findABCValue(Number(legId), Number(runnerId[1]), this.nestedArrayABC)
              :
            runnerId.toString();
          }
        }
        i++;
      });

      betAll.innerText = 'Clear';
    }

    const {
      resultStoreStructure,
      resultStoredSelectedRunners
    } = this.runnerService.betRunnersStringFormat(
      this.storeStructure,
      this.selectedModifier,
      this.elementRef,
    );
    this.storeStructure = resultStoreStructure;
    this.storedSelectedRunners = resultStoredSelectedRunners;

    // exotic must be stored
    if(
      this.isExoticSelections &&
      this.PoolIds.includes(this.selectedPool?.PoolId)
    ) {
      const storeStructureCopy = _.cloneDeep(this.storeStructure);
      this.storeStructureCopy = storeStructureCopy;
    }

    const {
      payload
    } = this.runnerService.showBet(
      true,
      this.storeStructure,
      this.dblPkArray,
      this.runnersInfo,
      this.currentEntries,
      this.legBets,
      this.selectedEvent,
      this.selectedRace,
      this.selectedPool,
      this.selectedModifier,
      this.baseAmount,
      this.poolMatrix,
      this.events,
      this.maxWagerTotal,
      this.legResult,
      this.dutchROI,
      this.dutchTicket,
      this.dutchAbcErrorMsg,
      this.abcTicket,
      this.abcTotalAmount,
      this.countryStateList,
      this.isBlockJurisdiction,
      this.isBlockJurisdictionMsg,
      this.cantBet,
      this.elementRef,
    );

    payload.storedSelectedRunners = this.storedSelectedRunners;
    // Keep per-runner stakes fresh: Dutch split when dutching, else null
    this.runnersWithStake = payload.runnersWithStake;
    this.doShowBetFn.emit(payload);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  betRace($event: any, poolId: string, roundId?: number, raceId?: number, legId?: number): void {
    if (!this.isOnline) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:betRace', false);
    }

    if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
      this.router.navigate(['login']);

      return;
    }

    if (!roundId || this.selectedPool === undefined) return;

    if (raceId) {
      // Active R# column is derived from showCurrentInfo via [class.active].
      this.showCurrentInfo = raceId;
      this.showCurrentInfoRunnersIndex = _.findIndex(
        this.dblPkArray, (item: any) => item.RaceId === raceId
      );
    }

    const bet = $event.target as HTMLElement;

    if (!this.runnerService.checkPool(poolId)) {

      let i = 0;
      let betSelector = '';
      bet.classList.forEach((item, index) => {
        if (index < 2 ) {
          betSelector = betSelector + '.' + item;
        }
      });

      const mutipleBetSelected = this.elementRef.nativeElement.querySelectorAll(
        '.table-runner i' + betSelector
      );
      mutipleBetSelected.forEach((betElem: HTMLElement) => {

        if (
          betElem?.classList.contains('active') &&
          !betElem?.classList.contains('couple-entry')
        ) {

          // abc
          if (
            this.selectedModifier.toLowerCase() === 'abc' &&
            this.runnerService.findABCValue(
              Number(legId),
              Number(roundId),
              this.nestedArrayABC
            ) !== ''
          ) {
            // nothing
          }
          else {
            betElem?.classList.remove('active');
            betElem.innerHTML = '';

            const {
              resultStoreStructure
            } = this.runnerService.removeRunnerFromLegByValue(
              Number(bet?.id),
              Number(bet?.classList[1].split('-')[1]),
              this.storeStructure
            );
            this.storeStructure = resultStoreStructure;

            const legIndex = this.storeStructure.findIndex(item => item.leg === Number(bet?.id));
            if (legIndex !== -1) {
              this.storeStructure.splice(legIndex, 1);
            }
          }

        }
        else if (i === 0 && betElem?.classList.contains('sub-couple-entry')) {
          betElem?.classList.add('active');
          const runnerId = betElem?.classList[0].split('-');
          betElem.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
          this.runnerService.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
            :
          runnerId[1]+betElem?.getAttribute('data-entry-id');
        }
        else if (betElem?.classList.contains('couple-entry')) {

          // abc
          if (
            this.selectedModifier.toLowerCase() === 'abc' &&
            this.runnerService.findABCValue(
              Number(legId),
              Number(roundId),
              this.nestedArrayABC
            ) !== ''
          ) {
            // nothing
          }
          else {
            betElem?.classList.remove('couple-entry');
            betElem.innerHTML = '';
          }
        }
        else if (i > 0) {
          if (betElem) {
            betElem?.classList.add('couple-entry');
            betElem.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.runnerService.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
              :
            roundId.toString()+betElem?.getAttribute('data-entry-id');
          }
        }
        else {
          if (betElem) {
            betElem?.classList.add('active');
            betElem.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.runnerService.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
              :
            roundId.toString();
          }
        }
        i++;
      });

    }
    else {

      let iTagCount = 0;
      let betSelector = '';
      bet.classList.forEach((item, index) => {
        if (index < 2 ) {
          betSelector = betSelector + '.' + item;
        }
      });

      const mutipleBetSelected = this.elementRef.nativeElement.querySelectorAll(
        '.table-runner i' + betSelector
      );

      mutipleBetSelected.forEach((betElem: HTMLElement) => {
        if (betElem)
          iTagCount++;
      });

      mutipleBetSelected.forEach((betElem: HTMLElement) => {

        if (
          betElem?.classList.contains('active') &&
          betElem?.tagName.toLowerCase() === 'i' &&
          !betElem?.classList.contains('couple-entry')
        ) {

          // abc
          if (
            this.selectedModifier.toLowerCase() === 'abc' &&
            this.runnerService.findABCValue(
              Number(legId),
              Number(roundId),
              this.nestedArrayABC
            ) !== ''
          ) {
            // nothing
          }
          else {
            betElem?.classList.remove('active');
            betElem.innerHTML = '';

            const {
              resultStoreStructure
            } = this.runnerService.removeRunnerFromLegByValue(
              Number(bet?.id),
              Number(bet?.classList[1].split('-')[1]),
              this.storeStructure
            );
            this.storeStructure = resultStoreStructure;

            const legIndex = this.storeStructure.findIndex(item => item.leg === Number(bet?.id));
            if (legIndex !== -1) {
              this.storeStructure.splice(legIndex, 1);
            }
          }
        }
        else if (
          iTagCount > 1 &&
          betElem?.classList.contains('sub-couple-entry') &&
          !betElem?.classList.contains('couple-entry')
        ) {
          betElem?.classList.add('couple-entry');
          const runnerId = betElem?.classList[0].split('-');
          betElem.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
          this.runnerService.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
            :
          runnerId[1]+betElem?.getAttribute('data-entry-id');
        }
        else if (betElem?.classList.contains('couple-entry')) {

          // abc
          if (
            this.selectedModifier.toLowerCase() === 'abc' &&
            this.runnerService.findABCValue(
              Number(legId),
              Number(roundId),
              this.nestedArrayABC
            ) !== ''
          ) {
            // nothing
          }
          else {
            betElem?.classList.remove('couple-entry');
            betElem?.classList.remove('active');
            betElem.innerHTML = '';
          }
        }
        else {
          if (betElem?.tagName.toLowerCase() === 'i') {
            betElem?.classList.add('active');
            betElem.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.runnerService.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
              :
            betElem.innerHTML = roundId.toString()+
            (
              betElem?.getAttribute('data-entry-id') ?
                betElem?.getAttribute('data-entry-id')
                  :
                ''
            );
          }
        }
      });
    }

    // abc
    if (this.selectedModifier.toLowerCase() === 'abc') {

      const currentValue = this.runnerService.findABCValue(
        Number(legId),
        Number(roundId),
        this.nestedArrayABC
      );
      const nextIndex = (this.abcArray.indexOf(currentValue) + 1) % this.abcArray.length;

      this.runnerService.setABCValue(
        Number(legId),
        Number(roundId),
        this.nestedArrayABC,
        this.abcArray[
          nextIndex
        ]
      )

      const divLegs = this.elementRef.nativeElement.querySelectorAll(
        '.table-runner .runner-' + roundId + '.leg-' + legId
      );

      divLegs.forEach((leg: HTMLElement) => {
        if (this.runnerService.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC))
          leg.innerHTML = this.runnerService.findABCValue(
            Number(legId),
            Number(roundId),
            this.nestedArrayABC
          );
        else {
          if (
            leg?.classList.contains('active') ||
            leg?.classList.contains('couple-entry')
          ) {
            leg?.classList.remove('active');
            leg?.classList.remove('couple-entry');
            leg.innerHTML = '';

            const {
              resultStoreStructure
            } = this.runnerService.removeRunnerFromLegByValue(
              Number(bet?.id),
              Number(bet?.classList[1].split('-')[1]),
              this.storeStructure
            );
            this.storeStructure = resultStoreStructure;

            const legIndex = this.storeStructure.findIndex(item => item.leg === Number(bet?.id));
            if (legIndex !== -1) {
              this.storeStructure.splice(legIndex, 1);
            }

          }
        }
      });
    }

    // add leg to store
    const {
      resultStoreStructure,
      resultStoredSelectedRunners
    } = this.runnerService.betRunnersStringFormat(
      this.storeStructure,
      this.selectedModifier,
      this.elementRef
    );
    this.storeStructure = resultStoreStructure;
    this.storedSelectedRunners = resultStoredSelectedRunners;
    // this.betRunnersStringFormat();

    // exotic must be stored
    if(
      this.isExoticSelections &&
      this.PoolIds.includes(this.selectedPool?.PoolId)
    ) {
      const storeStructureCopy = _.cloneDeep(this.storeStructure);
      this.storeStructureCopy = storeStructureCopy;
    }

    if (legId)
      this.runnerService.headLegSelector(
        this.storeStructure,
        legId,
        this.elementRef,
        this.renderer
      );

    const {
      payload
    } = this.runnerService.showBet(
      true,
      this.storeStructure,
      this.dblPkArray,
      this.runnersInfo,
      this.currentEntries,
      this.legBets,
      this.selectedEvent,
      this.selectedRace,
      this.selectedPool,
      this.selectedModifier,
      this.baseAmount,
      this.poolMatrix,
      this.events,
      this.maxWagerTotal,
      this.legResult,
      this.dutchROI,
      this.dutchTicket,
      this.dutchAbcErrorMsg,
      this.abcTicket,
      this.abcTotalAmount,
      this.countryStateList,
      this.isBlockJurisdiction,
      this.isBlockJurisdictionMsg,
      this.cantBet,
      this.elementRef,
      // this.commonFacade,
      // this.wagerFacade,
    );

    payload.storedSelectedRunners = this.storedSelectedRunners;
    // Keep per-runner stakes fresh: Dutch split when dutching, else null
    this.runnersWithStake = payload.runnersWithStake;
    this.doShowBetFn.emit(payload);
  }

  convertLegRange(
    legs?: number,
    poolRaces?: number,
    poolId?: string,
    currentPool?: any,
    modifier?: string
  ): any[] {

    return this.legResult = this.runnerService.betsLegRange(
      legs,
      poolRaces,
      poolId,
      currentPool,
      modifier
    );
  }

  /**
   * Dispatch Elo fetches for the current race(s) via the Elo service.
   * @returns {void}
   */
  private refreshEloRatings(): void {
    this.runnerService.refreshEloRatings(this.selectedRace, this.dblPkArray, this.eloRatings);
  }

  /**
   * Elo rating to display for a runner in a given race
   * @param {number} raceId Race the runner belongs to
   * @param {number} runnerId Runner id
   * @param {string | number} entryId Coupled-entry id (when present)
   * @returns {string} Elo rating, or '-' when unavailable
   */
  getRunnerElo(raceId?: number, runnerId?: number, entryId?: string | number | null): string {
    return this.runnerService.getRunnerElo(
      this.eloRatings,
      this.selectedRace?.eventId,
      raceId,
      runnerId,
      entryId
    );
  }

  /**
   * Stake to display for a runner: the Dutch-computed amount when present,
   * otherwise the base amount for a selected runner, else '-'.
   * runnersWithStake is keyed by runner id → [stake, payout].
   * @param {number} runnerId Runner id
   * @returns {string} Formatted stake, or '-'
   */
  getRunnerStake(runnerId?: number): string {
    if (runnerId == null) return '-';
    const dutchStake = this.runnersWithStake?.[runnerId]?.[0];
    if (dutchStake !== undefined && dutchStake !== null) return String(dutchStake);
    return this.isRunnerSelected(runnerId) && this.baseAmount ? String(this.baseAmount) : '-';
  }

  /**
   * Payout for a runner: $1 Pays × stake (legacy runner-table logic).
   * Non-Dutch pools apply the base bet amount to every runner (no selection
   * needed); Dutch pools use each runner's computed stake (0 until it forms a
   * valid combo). Formatted like legacy numberWithCommas (whole = integer,
   * fractional = 2 decimals, thousands separated).
   * @param {number} runnerId Runner id
   * @param {number} index Matrix column index for the runner
   * @returns {string} Formatted payout, or '-' when pays/amount unavailable
   */
  getRunnerPayout(runnerId?: number, index?: number): string {
    if (runnerId == null || index == null || index < 0) return '-';
    const price = this.matrix?.Rows?.[0]?.Columns?.[index]?.Price;
    const base = this.matrix?.PriceBaseWager;
    if (!price || !base) return '-';
    const onePays = parseFloat((price / base).toFixed(1));

    let stake: number;
    if (this.runnersWithStake) {
      // Dutch: per-runner stake ('-' means the runner isn't in a valid combo)
      const stakeText = this.getRunnerStake(runnerId);
      stake = stakeText !== '-' ? parseFloat(stakeText) : 0;
    } else {
      if (!this.baseAmount) return '-';
      stake = this.baseAmount;
    }

    const payout = onePays * stake;
    if (isNaN(payout)) return '-';
    const formatted = payout % 1 === 0 ? String(Math.floor(payout)) : payout.toFixed(2);
    return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * Whether a runner is currently picked in any leg of the store structure.
   * @param {number} runnerId Runner id
   * @returns {boolean} True when the runner is selected
   */
  private isRunnerSelected(runnerId: number): boolean {
    return this.storeStructure?.some(
      leg => Array.isArray(leg?.runners) && leg.runners.includes(runnerId)
    ) || false;
  }

  trackByRunners(index: number, item: any) {
    return item.RunnerId;
  }

  trackByEntries(index: number, item: any) {
    return item.Position;
  }

  /**
   * Rebuild the precomputed view model for the Pick/DBL multi-race table.
   * Called whenever dblPkLegs, dblPkArray, or the active race changes.
   * @returns {void}
   */
  private rebuildDblPkLegsView(): void {
    if (!this.dblPkArray?.length || !this.dblPkLegs?.length) {
      this.dblPkLegsView = [];
      return;
    }
    // Defensive clamp: if the stored active-race index points past the
    // new dblPkArray (can happen on rapid pool switches like PK4 -> DBL
    // where the previous index was 3 but the new array only has 2 races)
    // fall back to race 0 so the table never renders an empty identity.
    let activeIdx = this.showCurrentInfoRunnersIndex ?? 0;
    if (activeIdx < 0 || activeIdx >= this.dblPkArray.length) {
      activeIdx = 0;
      this.showCurrentInfoRunnersIndex = 0;
    }
    const activeRace = this.dblPkArray[activeIdx];
    const activeRunners: any[] = activeRace?.Runners || [];
    const useMatrix =
      !!activeRace &&
      !!this.selectedRace &&
      activeRace.RaceId === this.selectedRace.RaceId;

    this.dblPkLegsView = this.dblPkLegs.map((leg: any) => {
      const cells = this.dblPkArray.map(
        (race: any) =>
          leg?.Entries?.find((e: any) => e?.RaceId === race.RaceId) || null,
      );
      const identity = cells[activeIdx] || null;
      const isFullyHidden = cells.every((c: any) => !c || c.toHide);
      const isActiveHidden = !identity || !!identity.toHide;
      const runnerIndex = identity
        ? activeRunners.findIndex((r: any) => r?.RunnerId === identity.RunnerId)
        : -1;
      return {
        identity,
        cells,
        isFullyHidden,
        isActiveHidden,
        runnerIndex,
        useMatrix,
        uiClass: identity
          ? 'runner-ui-' + identity.RunnerId + '-' + (identity.EntryId ? 2 : 1)
          : '',
        idClass: identity ? 'runner-id-' + identity.RunnerId : '',
        activeRaceId: activeRace?.RaceId,
      };
    });

    this.cdRef.markForCheck();
  }

  /**
   * Get available replays for the given precomputed row view.
   * Matches by RunnerId + name (since replays records do not carry EntryId).
   * @param {any} legView - Precomputed leg view
   * @returns {any[]} - Slice of up to 5 available replays
   */
  getReplaysFor(legView: any): any[] {
    if (!this.runnerWithReplays?.length || !legView?.identity) return [];
    const id = legView.identity;
    if (id.toHide || id.isReplica || !id.Name) return [];

    const runnerRecord = this.runnerWithReplays.find(
      (r: any) => r.runnerId === id.RunnerId,
    );
    if (!runnerRecord?.entries?.length) return [];

    const matched = runnerRecord.entries.find((e: any) => e?.name === id?.Name);
    return matched?.availableReplays?.slice(0, 5) || [];
  }

  /**
   * Stable trackBy for dblPkLegsView rows.
   * @param {number} _ - Index (unused)
   * @param {any} legView - Precomputed leg view
   * @returns {string} - Stable row id
   */
  trackByLegView(_: number, legView: any): string {
    const id = legView?.identity;
    return `${id?.RunnerId ?? ''}-${id?.EntryId ?? ''}`;
  }

  /**
   * Stable trackBy for race columns.
   * @param {number} _ - Index (unused)
   * @param {any} race - Race entry
   * @returns {number} - RaceId
   */
  trackByRaceId(_: number, race: any): number {
    return race?.RaceId;
  }

  /**
   * Optional pivoted view: races, each with the runners that actually run in them.
   * @returns {{ RaceId: number; Runners: any[] }[]} - Per-race runners
   */
  get racesView(): { RaceId: number; Runners: any[] }[] {
    if (!this.dblPkArray?.length || !this.dblPkLegs?.length) return [];
    return this.dblPkArray.map((race: any) => ({
      RaceId: race.RaceId,
      Runners: this.dblPkLegs
        .map((leg: any) =>
          leg?.Entries?.find((e: any) => e?.RaceId === race.RaceId),
        )
        .filter((e: any) => e && !e.toHide && !e.isReplica),
    }));
  }

  /**
   * Show an info/error alert through the shared Material dialog.
   * Bet submit / save flows live in `BetPreviewComponent`; this helper
   * is only used for the runner UI's own permission / connectivity /
   * validation messages.
   *
   * @param {string} hdr - Header text
   * @param {string} msg - Body message
   * @param {string} btn - Reserved (kept for API parity with the legacy ion impl)
   * @param {number} status - Reserved (kept for API parity with the legacy ion impl)
   * @returns {Promise<void>}
   */
  async showAlertInfo(hdr: string, msg: string, btn: string, status: number): Promise<void> {
    this.matNotificationService.showAlert(
      hdr,
      msg,
      '',
      '',
      'Close',
    );
  }

  /**
   * Show basic
   * click event
   * @returns {void}
   */
  showBasic(): void {
    if (!this.isOnline) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:showBasic', false);
    }

    if (!this.runnerService.hasPermission(this.permissionService, this.router)) {

      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('Info', 'You are not an Identified User.', 'Close', 0);
      }

      return;
    }

    this.controller = _.mapValues(this.controller, c => c === true ? false : c);
    this.controller.basic = true;
    this.runnerWithReplays = [];
    this.isLoadingReplays = false;

    // setTimeout(()=>{
    //   this.runnerService.setLegBetHeight(
    //     this.elementRef,
    //     this.dblPkArray,
    //     this.runnersInfo.toArray(),
    //     this.currentEntries.toArray()
    //   );
    // }, 100);

  }

  /**
   * Show info
   * click event
   * @returns {void}
   */
  showInfo(): void {
    if (!this.isOnline) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:showInfo', false);
    }

    if (!this.runnerService.hasPermission(this.permissionService, this.router)) {

      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('Info', 'You are not an Identified User.', 'Close', 0);
      }

      return;
    }

    this.controller = _.mapValues(this.controller, c => c === true ? false : c);
    this.controller.info = true;
    this.runnerWithReplays = [];
    this.isLoadingReplays = false;

    // setTimeout(()=>{
    //   this.runnerService.setLegBetHeight(
    //     this.elementRef,
    //     this.dblPkArray,
    //     this.runnersInfo.toArray(),
    //     this.currentEntries.toArray()
    //   );
    // }, 100);

  }

  /**
   * Show stats
   * click event
   * @returns {void}
   */
  showStats(): void {
    if (!this.isOnline) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:showStats', false);
    }

    if (!this.runnerService.hasPermission(this.permissionService, this.router)) {

      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('Info', 'You are not an Identified User.', 'Close', 0);
      }

      return;
    }

    this.controller = _.mapValues(this.controller, c => c === true ? false : c);
    this.controller.stats = true;
    this.runnerWithReplays = [];
    this.isLoadingReplays = false;

    // setTimeout(()=>{
    //   this.runnerService.setLegBetHeight(
    //     this.elementRef,
    //     this.dblPkArray,
    //     this.runnersInfo.toArray(),
    //     this.currentEntries.toArray()
    //   );
    // }, 100);

  }

  /**
   * Show replays
   * click event
   * @returns {Promise<void>}
   */
  async showReplays(): Promise<void> {
    if (!this.isOnline) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:showReplays', false);
    }

    if (!this.runnerService.hasPermission(this.permissionService, this.router)) {

      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('Info', 'You are not an Identified User.', 'Close', 0);
      }

      return;
    }

    this.runnerWithReplays = [];

    if (this.isLoadingReplays)
      return;

    if (this.indexCountReplays)
      this.indexCountReplays = 0;

    const result = await this.runnerService.getReplaysRunnerData(
      this.selectedRace,
      this.dblPkArray,
      this.runnersInfo.toArray(),
      this.currentEntries.toArray()
    );

    if (result.indexGetReplays) {
      const grouped = _.groupBy(result.runnerWithReplays, 'runnerId');
      const formatted = Object.entries(grouped).map(([runnerId, entries]) => ({
        runnerId: Number(runnerId),
        entries: entries
      }));

      this.runnerWithReplays = formatted;
      this.indexGetReplays = Math.abs(result.indexGetReplays - result.indexLengthToRemove);
    }

    this.controller = _.mapValues(this.controller, c => c === true ? false : c);
    this.controller.replays = true;
    this.isLoadingReplays = true;

    // this.runnerService.setLegBetHeight(
    //   this.elementRef,
    //   this.dblPkArray,
    //   this.runnersInfo.toArray(),
    //   this.currentEntries.toArray()
    // );
  }

  /**
   * Get replay video
   * click event
   * @param {any} replay - Replay object
   * @returns {void}
   */
  getReplayVideo(replay: any): void {
    this.replayRequested.emit();

    this.wagerFacade.getEventRaceVideoReplay(
      'RunnerComponent:getReplayVideo',
      {
        toteEventId: replay?.trackId,
        toteRaceId: replay?.race,
        raceDay: this.runnerService.toDate(new Date(replay?.date), 2),
        width: 640,
        height: 500
      }
    );

    this.wagerFacade.setSelectedReplayInfo(
      replay?.track,
      replay?.date,
      replay?.breed,
      replay?.race,
      this.selectedEvent?.ToteResponse?.RunId,
      replay?.trackId,
      this.selectedPool?.PoolId,
      true
    );
  }

}
